import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onCtaClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_zeropower/artifacts/hsn059yp_NEW%20STYLE.jpg" 
              alt="Bijaya Solar - Registered Vendor for PM Surya Ghar Yojana"
              className="h-12 md:h-16 w-auto object-contain max-w-[280px]"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('subsidy')}
              className="text-gray-700 hover:text-orange-500 font-medium"
            >
              Subsidy
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="text-gray-700 hover:text-orange-500 font-medium"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-gray-700 hover:text-orange-500 font-medium"
            >
              Testimonials
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="text-gray-700 hover:text-orange-500 font-medium"
            >
              Process
            </button>
            <a href="tel:+919262626026" className="flex items-center space-x-2">
              <Button className="bg-orange-500 hover:bg-orange-600 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 bg-white border-t">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('subsidy')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left"
              >
                Subsidy
              </button>
              <button
                onClick={() => scrollToSection('why-us')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left"
              >
                Why Us
              </button>
              <button
                onClick={() => scrollToSection('testimonials')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left"
              >
                Testimonials
              </button>
              <button
                onClick={() => scrollToSection('process')}
                className="text-gray-700 hover:text-orange-500 font-medium text-left"
              >
                Process
              </button>
              <a href="tel:+919262626026">
                <Button className="bg-orange-500 hover:bg-orange-600 text-white w-full">
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now
                </Button>
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;